import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Confirm } from "../../components/confirm";
import { deleteBoardMeeting } from "../../services/board-meeting";
import { useLocale } from "../../stores/locale";
import { navigateBack } from "../../utils/navigate-back";

export function BoardMeetingDelete() {
  const navigate = useNavigate();
  const locale = useLocale((state) => state);
  const queryClient = useQueryClient();
  const { id } = useParams();

  if (!id) {
    throw new Error("Board meeting ID is required");
  }

  const [loading, setLoading] = useState(false);

  return (
    <Confirm
      header={locale.get("boardMeeting.confirmDelete")}
      loading={loading}
      onClose={() => navigateBack(navigate, "/admin/board-meeting/list")}
      onConfirm={() => {
        (async () => {
          setLoading(true);
          try {
            await deleteBoardMeeting(id);
            await queryClient.invalidateQueries({
              queryKey: ["board-meetings"],
            });
            queryClient.removeQueries({ queryKey: ["board-meeting", id] });
            navigate("/admin/board-meeting/list", { replace: true });
          } finally {
            setLoading(false);
          }
        })();
      }}
    />
  );
}
